import { Route, Routes } from 'react-router-dom';


import ReportsDashboard from '../components/Reports';


const Reports = () => {
  return (
    <Routes>
      <Route path="/" element={<ReportsDashboard />} />
    </Routes>
  )
}

export default Reports;